import { Suppliers } from './Suppliers';
import { ReplacementModule } from "./ReplacementModule";
import { Contract } from "@/entity/Net20/Contract";

export class SupplierRequestHistory {
    public id: string;
    public idContract: string;
    public emails: string;
    public dateRequest: Date;
    public signCustomization: string;
    public signType: string;
    public signSize: string;
    public signBrandCustomization: string;
    public signNameText: string;
    public signTelephone: string;
    public note: string;
    public replacementType: string;
    public replacementModules: Array<ReplacementModule>;
    public requestType: string;
    public supplier: Suppliers;

    constructor(id?: string
                , idContract?: string
                , emails?: string
                , dateRequest?: Date
                , signCustomization?: string
                , signType?: string
                , signSize?: string
                , signBrandCustomization?: string
                , signNameText?: string
                , signTelephone?: string
                , note?: string
                , replacementType?: string
                , supplier?: Suppliers) {
        this.id = id;
        this.idContract = idContract;
        this.emails = emails;
        this.dateRequest = dateRequest;
        this.signCustomization = signCustomization;
        this.signType = signType;
        this.signSize = signSize;
        this.signBrandCustomization = signBrandCustomization;
        this.signNameText = signNameText;
        this.signTelephone = signTelephone;
        this.note = note;
        this.replacementType = replacementType;
        this.supplier = supplier;
    }

    initFromContract(customerContract: Contract){
        this.idContract = customerContract.id;
        this.signCustomization = customerContract.signCustomization;
        this.signType = customerContract.signType;
        this.signSize = customerContract.signSize;
        this.signBrandCustomization = customerContract.signBrandCustomization;
        this.signNameText = customerContract.signNameText;
        this.signTelephone = customerContract.signTelephone;
        this.note = customerContract.note;
    }
}